import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject } from 'rxjs'
import { ValidationState, WorkItem, WorkItemSegment, WorkItemSegmentState } from '../work-item'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatIcon } from '@angular/material/icon'
import { MatBadge } from '@angular/material/badge'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-item-manufacturing-status',
  templateUrl: './item-manufacturing-status.component.html',
  styleUrls: ['./item-manufacturing-status.component.scss'],
  imports: [MatBadge, MatIcon, AsyncPipe, ElderTranslatePipe],
})
export class ItemManufacturingStatusComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly logger = LoggerFactory.getLogger(this.constructor.name)

  public readonly item$ = new BehaviorSubject<WorkItem>(null)

  public readonly ValidationState = ValidationState

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Getters / Setters                                                       *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set item(item: WorkItem) {
    this.item$.next(item)
  }

  public get item(): WorkItem {
    return this.item$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public segmentIcon(segment: WorkItemSegment): string {
    switch (segment.state) {
      case WorkItemSegmentState.OPEN:
        return 'radio_button_unchecked'
      case WorkItemSegmentState.PROCESSING:
        return 'play_circle_outline'
      case WorkItemSegmentState.COMPLETED:
        return 'check_circle_outline'
      default:
        return 'help_outline'
    }
  }
}
